import { Component, OnInit, Inject } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-liste-valeur-caracteristique-modal',
  templateUrl: './liste-valeur-caracteristique-modal.component.html',
  styleUrls: ['./liste-valeur-caracteristique-modal.component.scss']
})
export class ListeValeurCaracteristiqueModalComponent implements OnInit {

  constructor(private router:Router,public generalService:GeneralService,public dialogRef: MatDialogRef<ListeValeurCaracteristiqueModalComponent>, @Inject(MAT_DIALOG_DATA) public data) { }

  valueCaracteristique = [];
  ecArtCar_Val;
  exist : boolean = true;
  ngOnInit() 
  {
    if(this.generalService.userConnecter == "")
    {
      this.router.navigate([""]);
    }
    else
    {
      this.exist = false;
      this.getvalueCaracteristique()
    }
    
  }
  getvalueCaracteristique()
  {
    if(this.data.ecArtCar_Id != undefined && !isNaN(this.data.ecArtCar_Id))
    {
      this.generalService.rechercheTable(this.generalService.urllisteValeurCaracteristique+this.data.ecArtCar_Id).subscribe(data =>
      {
        this.valueCaracteristique = data;
        this.exist = true;
      },
      err =>
      {
        this.valueCaracteristique =  []
      })       
    }
    else
    {
      this.exist = false;
      this.valueCaracteristique =  [] 
    }
    
  }
  onvalueCaracteristiqueChange(value)
  {
    var result = this.valueCaracteristique.find((element) =>
    {
        return element.ecArtCarValList_Id==value;
    });
    if(result != undefined)
    {
      this.data.ecArtCar_Val = result.ecArtCarValList_Label;
    }
  } 
}
